import Footer from '../../components/Footer';
import Header from '../../components/Header';
import ChangeEmailForm from '../../forms/email-verification/ChangeEmailForm';

const ChangeEmailPage = () => {
    return (
        <section className='eh-page eh-page-change-email'>
            <Header />
            <ChangeEmailForm />
            <Footer />
        </section>
    );
};

export default ChangeEmailPage;
